import React, { useState } from "react";

const CollapsibleText = ({content}) => {
  const [showFullText, setShowFullText] = useState(false);
  
  const shouldCollapse = content.length > 300
  const preview = content.slice(0,300);

  const show = () => {
    setShowFullText(true);
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {shouldCollapse && !showFullText && 
          (<React.Fragment>
            <div dangerouslySetInnerHTML={{__html: preview }} /> 
            <span 
              onClick={show}
              className="text-primary cursor-pointer">... See more</span>
          </React.Fragment>)
        }

        { (!shouldCollapse || showFullText) &&
          (
            <div dangerouslySetInnerHTML={{__html: content }} />
          )
        }
      </div>
    </div>
  );
}

export default CollapsibleText;
